/* Customily injects #customily-preview-button into .product-form__buttons
   (alongside the theme's add-to-cart). Move it INSIDE #cl_optionsapp so
   the gray personalization card visually contains the preview action,
   matching the Customall product layout (where .btn-preview sits inside
   .ctm-customize-product). */
(function () {
  var LOG = '[customily-preview-mover]';

  function movePreviewIntoCard() {
    var card = document.querySelector('#cl_optionsapp');
    var btn = document.querySelector('#customily-preview-button');
    if (!card || !btn) return false;
    if (card.contains(btn)) return true;
    try {
      card.appendChild(btn);
      console.log(LOG, 'moved #customily-preview-button into #cl_optionsapp');
      return true;
    } catch (e) {
      console.error(LOG, 'move failed:', e);
      return false;
    }
  }

  function init() {
    console.log(LOG, 'init');
    movePreviewIntoCard();

    /* Customily mounts asynchronously and may re-render the button on
       variant change. Watch the DOM for ~60s and keep moving as needed. */
    var observer = new MutationObserver(movePreviewIntoCard);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* When the cart drawer opens after add-to-cart, Customily's app-level
   "Sticky Preview" (toggled on in Customily admin) can render above
   the drawer due to stacking-context quirks (its parent .product__media-
   item may create a new stacking context, escaping a pure z-index fix).
   Tag <body> with `cart-open` while EITHER Dawn's `<cart-drawer>` has
   the `.active` class OR the external SlideCartHQ drawer is visible —
   companion CSS hides .cl-canvas-container while the class is present. */
(function () {
  function isVisible(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function update() {
    var slidecartOpen = isVisible(document.querySelector('.slidecarthq'));
    var dawnCartOpen = !!document.querySelector('cart-drawer.active');
    document.body.classList.toggle('cart-open', slidecartOpen || dawnCartOpen);
  }

  function watch() {
    update();
    var observer = new MutationObserver(update);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
